const STORAGE_KEY = 'viewed-releases';

export function getViewedReleaseIds(): string[] {
  const storedReleases = localStorage.getItem(STORAGE_KEY);

  try {
    const viewedReleases = JSON.parse(storedReleases ?? '[]');
    if (!Array.isArray(viewedReleases)) {
      return [];
    }
    return viewedReleases;
  } catch {
    return [];
  }
}

export function isReleaseViewed(releaseId: string): boolean {
  const viewedReleases = getViewedReleaseIds();
  return viewedReleases.includes(releaseId);
}

export function markAllReleasesAsViewed(releaseIds: string[]): void {
  const viewedReleases = getViewedReleaseIds();
  const updatedViewed = [...new Set([...viewedReleases, ...releaseIds])];
  localStorage.setItem(STORAGE_KEY, JSON.stringify(updatedViewed));
}

export function generateStableId(date: string, title: string): string {
  const [datePrefix] = date.split('T');

  let hash = 0;
  for (let i = 0; i < title.length; i++) {
    const char = title.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash;
  }
  const titleHash = Math.abs(hash).toString(36);

  return `${datePrefix}-${titleHash}`;
}
